import { dew as _createClientDew } from "./createClient.js";
import { dew as _testDew } from "./decorators/test.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createTestClient = void 0;
  const createClient_js_1 = _createClientDew();
  const test_js_1 = _testDew();
  function createTestClient(parameters) {
    const {
      key = "test",
      name = "Test Client",
      mode
    } = parameters;
    const client = (0, createClient_js_1.createClient)({
      ...parameters,
      key,
      name,
      type: "testClient"
    });
    return client.extend(config => ({
      mode,
      ...(0, test_js_1.testActions)({
        mode
      })(config)
    }));
  }
  exports.createTestClient = createTestClient;
  //# sourceMappingURL=createTestClient.js.map
  return exports;
}